import { VERSION } from "../../index.js";

export function versionCommand(): void {
  console.log(`reasonix ${VERSION}`);
}
